import '~/js/sections/weddings/includes/stickyNav';
import photographyLocations from '~/js/sections/weddings/includes/local-photographers.js';
import '~/js/libs/jquery-ui.selectmenu.min.js';

const photoArray = photographyLocations.locations;
const pageSections = ['.header-section', '.resort-container', '.resorts-section'];

/* Hides the original page */
function hidePage() {
  pageSections.forEach(section => {
    const currentSection = document.querySelector(section);

    currentSection.classList.add('inactive');
  });
}

/* Closes the Modals */
function removeModals() {
  const modals = document.querySelector('.photo-spot');

  modals.innerHTML = '';

  pageSections.forEach(section => {
    const currentSection = document.querySelector(section);

    currentSection.classList.remove('inactive');
  });
}

/* HTML for the Modal pop up */
function pageDisplay(obj) {
  const currentCountry = obj.country;
  const section = `
    <div class="added-in">
        <div class="container">
            <div class="row">
                <div class="xs-12 xxl-offset-1 xxl-11 added-header">
                    <h2><i class="icon-logo-Beaches-new"></i><br>${obj.name}</h2>
                    <p>RESORT PHOTOGRAPHY</p>
                </div>
                <div class="xs-12 json-nav-bar">
                    <div class="tab-wrapper">
                        <div class="xxl-offset-1 back-tab">
                            <a class="learnmore titleCopy close-modal" href=""><i class="icon-button-arrow-prev"></i>${obj.country}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="collage-photo">
            <img src="${obj.img}" alt="">
        </div>
    </div>`;

  $('.photo-spot').append(section);
  scroll(0, 0);

  const moreTab = `
                    <div class="more-tab">
                        <a class="accordion"><span class="accordion" id="plus-sign">+</span></a>
                    </div>
                    <div class="locations-accordion">
                        <ul>
                        </ul>
                    </div>`;

  $('.tab-wrapper').append(moreTab);

  photoArray.forEach(item => {
    if (item.country === currentCountry) {
      if (item.code === obj.code) {
        return;
      }
      const listItem = `<li><a class="open-modal "data-loc="${item.code}">${item.name}</a></li>`;

      $('.locations-accordion ul').append(listItem);
    }
  });
}

/* Matches click with Object */
function showSamples(loc) {
  photoArray.find((i) => {
    if (i.code === loc) {
      pageDisplay(i);
    }
  });
}

/* Opens and closes accordion menu */
function accordionAction() {
  const plusSign = document.querySelector('#plus-sign');
  const locationsAccordion = document.querySelector('.locations-accordion');

  plusSign.classList.toggle('rotate-span');

  if (locationsAccordion.style.maxHeight) {
    locationsAccordion.style.maxHeight = null;
  } else {
    locationsAccordion.style.maxHeight = locationsAccordion.scrollHeight + 'px';
  }
}

/** SELECT MENU FOR MOBILE SCREENS **/
const resortSelectHandler = (event, data) => {
  if (data.item.value !== '') {
    const currentResort = $('.active-resort');


    currentResort.addClass('inactive');
    currentResort.removeClass('active-resort');

    const selectedResort = $('#js-resort-select').val();

    const selectedResortValue = selectedResort;
    const activeCountry = $(`.${selectedResortValue}-resorts`);

    activeCountry.addClass('active-resort');
    activeCountry.removeClass('inactive');
    $('.lazyload').trigger('unveil');
  }
};

const $resortSelect = $('#js-resort-select');

$resortSelect.selectmenu({
  appendTo: $resortSelect.parent(),
  change: resortSelectHandler
});

/** RESIZING FOR NAV BAR **/
const weddingActiveTabCover = document.querySelector('.weddingTabs .activeTabNav');
const weddingActiveTab = document.querySelector('.weddingTabs li.active');

weddingActiveTabCover.style.width = `${weddingActiveTab.offsetWidth}px`;
weddingActiveTabCover.style.left = `${weddingActiveTab.offsetLeft}px`;

/** DISPLAYS CURRENT RESORT AND HIDES OTHERS **/
function resortDisplay() {
  const navBarItems = Array.from(document.querySelectorAll('.weddingTabs li'));

  navBarItems.shift();
  navBarItems.forEach((item) => {
    item.addEventListener('click', () => {
      const currentSelection = document.querySelector('li.active');

      currentSelection.classList.remove('active');
      item.classList.add('active');

      const currentResort = document.querySelector('.active-resort');
      const newCurrentResort = document.querySelector(`.${item.getAttribute('data-country')}-resorts`);

      currentResort.classList.add('inactive');
      currentResort.classList.remove('active-resort');
      newCurrentResort.classList.add('active-resort');
      newCurrentResort.classList.remove('inactive');
      weddingActiveTabCover.style.left = `${item.offsetLeft}px`;
      $('.lazyload').trigger('unveil');
    });
  });
}

/** DEBOUNCE **/
const weddingTabs = _.debounce(() => {
  weddingActiveTabCover.style.width = `${document.querySelector('.weddingTabs li.active').offsetWidth}px`;
  weddingActiveTabCover.style.left = `${document.querySelector('.weddingTabs li.active').offsetLeft}px`;
}, 300);

window.addEventListener('resize', weddingTabs);
resortDisplay();

/* Click Event Listeners */
document.onclick = (event) => {

  if (event.target.classList.contains('open-modal')) {
    const location = event.target.getAttribute('data-loc');

    removeModals();
    hidePage();
    showSamples(location);
    event.preventDefault();
  }

  if (event.target.classList.contains('close-modal')) {
    removeModals();
    weddingTabs();
    event.preventDefault();
  }

  if (event.target.classList.contains('accordion')) {
    accordionAction();
  }

};
